import actions from "./actions";

const {FETCH_FINAL, FETCH_FINAL_ATTENDANCE} = actions;
const initState = {
    final: [],
    finalAttendance: []
};

const FinalReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_FINAL:
            return {
                ...state,
                final: data
            }
        case FETCH_FINAL_ATTENDANCE:
            return {
                ...state,
                finalAttendance: data
            }
        default:
            return state;
    }
}

export default FinalReducer;
